import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export function Input({ ...props }: InputProps) {
  return (
    <input
      style={{
        backgroundColor: 'var(--color-surface-3)',
        color: 'var(--color-text-primary)',
        border: '1px solid var(--color-border)',
        borderRadius: 'var(--radius-sm)',
        padding: 'var(--space-2) var(--space-3)',
        fontSize: 'var(--text-base)',
        fontFamily: 'var(--font-sans)',
        transition: 'border-color 0.2s ease',
      }}
      className="input-touch"
      {...props}
    />
  );
}

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  children: React.ReactNode;
}

export function Select({ children, ...props }: SelectProps) {
  return (
    <select
      style={{
        backgroundColor: 'var(--color-surface-3)',
        color: 'var(--color-text-primary)',
        border: '1px solid var(--color-border)',
        borderRadius: 'var(--radius-sm)',
        padding: 'var(--space-2) var(--space-3)',
        fontSize: 'var(--text-base)',
        fontFamily: 'var(--font-sans)',
        cursor: 'pointer',
      }}
      className="input-touch"
      {...props}
    >
      {children}
    </select>
  );
}

interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {}

export function Textarea({ ...props }: TextareaProps) {
  return (
    <textarea
      style={{
        backgroundColor: 'var(--color-surface-3)',
        color: 'var(--color-text-primary)',
        border: '1px solid var(--color-border)',
        borderRadius: 'var(--radius-sm)',
        padding: 'var(--space-3)',
        fontSize: 'var(--text-base)',
        fontFamily: 'var(--font-sans)',
        resize: 'vertical',
        transition: 'border-color 0.2s ease',
      }}
      {...props}
    />
  );
}
